var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "\t#1e3a8a",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24.00 24.00",
    id: "chart-column-grow",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    stroke: "\t#1e3a8a",
    strokeWidth: 0.00024000000000000003,
    transform: "matrix(1, 0, 0, 1, 0, 0)rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.096
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M22,6.76l-1-4A1,1,0,0,0,20,2H16a1,1,0,0,0,0,2h2.12C13.79,9.69,5.9,11,3,11a1,1,0,0,0,0,2c3.16,0,11.71-1.45,16.56-7.63L20,7.24A1,1,0,1,0,22,6.76Z",
    style: {
      fill: "#1e3a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M23,11V21a1,1,0,0,1-1,1H19a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1h3A1,1,0,0,1,23,11Zm-9,3H11a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V15A1,1,0,0,0,14,14ZM6,16H3a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H6a1,1,0,0,0,1-1V17A1,1,0,0,0,6,16Z",
    style: {
      fill: "#1e3a8a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowChart);
export default __webpack_public_path__ + "static/media/grow_chart.1307406c1813dc6d8cb865e47151f868.svg";
export { ForwardRef as ReactComponent };